/* Bezzati — auto-advancing photo carousels (product cards + PDP gallery).
   Autoplay starts immediately and is only ever PAUSED by visibility/hover,
   so a browser without a working IntersectionObserver still animates.
   Respects prefers-reduced-motion: arrows keep working, autoplay stays off. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initCarousel(root, opts) {
    opts = opts || {};
    var slideSel = opts.slideSelector || '.bz-card__slide';
    var slides = Array.prototype.slice.call(root.querySelectorAll(slideSel));
    if (slides.length < 2) return null;

    var index = 0;
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('is-active')) { index = i; break; }
    }

    var timer = null;
    var cycle = parseInt(root.dataset.cycle, 10) || 8000;
    var startDelay = parseInt(root.dataset.start, 10) || 0;
    var offscreen = false;
    var hovered = false;

    function show(i) {
      index = (i + slides.length) % slides.length;
      for (var n = 0; n < slides.length; n++) {
        slides[n].classList.toggle('is-active', n === index);
      }
      if (typeof opts.onChange === 'function') opts.onChange(index);
    }
    function next() { show(index + 1); }
    function prev() { show(index - 1); }

    function play() {
      if (reduce || timer || offscreen || hovered) return;
      timer = setInterval(next, cycle);
    }
    function pause() { if (timer) { clearInterval(timer); timer = null; } }

    var prevBtn = root.querySelector('[data-bz-prev]');
    var nextBtn = root.querySelector('[data-bz-next]');
    if (prevBtn) prevBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); pause(); prev(); play(); });
    if (nextBtn) nextBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); pause(); next(); play(); });

    root.addEventListener('mouseenter', function () { hovered = true; pause(); });
    root.addEventListener('mouseleave', function () { hovered = false; play(); });
    root.addEventListener('focusin', function () { hovered = true; pause(); });
    root.addEventListener('focusout', function () { hovered = false; play(); });

    // Start now (staggered), so autoplay never depends on an observer firing.
    if (startDelay) setTimeout(play, startDelay); else play();

    // Visibility is an optimisation only: pause off-screen, resume on-screen.
    if ('IntersectionObserver' in window) {
      try {
        new IntersectionObserver(function (entries) {
          for (var e = 0; e < entries.length; e++) {
            offscreen = !entries[e].isIntersecting;
            if (offscreen) pause(); else play();
          }
        }, { threshold: 0.15 }).observe(root);
      } catch (err) { /* observer unavailable — autoplay already running */ }
    }

    // Stop work entirely when the tab is hidden.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) pause(); else play();
    });

    return {
      show: show, next: next, prev: prev, play: play, pause: pause,
      get index() { return index; },
      length: slides.length
    };
  }

  window.BzCarousel = { init: initCarousel };

  function boot() {
    var nodes = document.querySelectorAll('[data-bz-carousel]');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].dataset.bzReady) continue;
      nodes[i].dataset.bzReady = '1';
      initCarousel(nodes[i]);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();